import { createMuiTheme } from "@material-ui/core/styles";

const defaultTheme = createMuiTheme();

export default createMuiTheme({
  palette: {
    primary: {
      main: "#1d1d1b",
    },
    common: {
      white: "black",
    },
    grey: {
      500: defaultTheme.palette.grey[600],
    },
  },
});
